const lbModal = angular.module('app.lbModal', []);

lbModal.controller('lbModalCtrl', require('./lbModalCtrl'));
lbModal.directive('lbModal', require('./lbModalDir'));
lbModal.service('lbModalService', require('./lbModalService'));

export default lbModal;


// WEBPACK FOOTER //
// ./src/components/lbModal/index.js